export class AnalyzerDietarytypeMapping {
  AnalyzerId?: number;
  DietarytypeIds: number[];
  OrgId?: number;
  CreatedBy?: number;
}
